import * as Sentry from "@sentry/browser";

const environment = () => {
  let env = import.meta.env.MODE;

  if (import.meta.env.MODE !== 'test') {
    if (window.location.hostname.includes('local')) {
      env = 'local';
    } else if (window.location.hostname.includes('develop')) {
      env = 'development';
    } else if (window.location.hostname.includes('uat')) {
      env = 'uat';
    } else if (window.location.hostname.includes('staging')) {
      env = 'staging';
    } else {
      env = 'production';
    }
  }

  return env;
};

const currentEnvironment = environment();
const ignoredErrorFragments = [
  "Compiled URL https://mention-me.com",
  "Creating an embed of:",
  "Beginning display of:",
  "Triggered Event: open https://tag.mention-me.com",
  "A tag has already fired with identifier",
  "Could not find wrapper mmWrapper",
  "Found wrapper mmWrapper"
];
const normalizedIgnoredErrorFragments = ignoredErrorFragments.map((fragment) => fragment.toLowerCase());

const safeStringify = (value) => {
  if (value === null || typeof value === "undefined") {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  try {
    const serialized = JSON.stringify(value);
    return typeof serialized === "string" ? serialized : String(value);
  } catch (_error) {
    return String(value);
  }
};

const hasIgnoredFragment = (value) => {
  const text = safeStringify(value).toLowerCase();
  return text && normalizedIgnoredErrorFragments.some((fragment) => text.includes(fragment));
};

const shouldDropIgnoredErrorEvent = (event) => {
  if (!event) {
    return false;
  }

  const candidates = [
    event.message,
    event.logentry?.message,
    event.logentry?.formatted,
    event.exception?.values,
    event.extra?.arguments,
    event.breadcrumbs
  ];

  return candidates.some(hasIgnoredFragment);
};

window.sentryOptions = {
  dsn: "https://855d94b052d142f69d390f8220d05fcd@monitor.ripethinking.co.uk/12",
  enabled: currentEnvironment !== "test" && currentEnvironment !== "local",
  environment: currentEnvironment,
  release: typeof __SENTRY_RELEASE__ !== "undefined" ? __SENTRY_RELEASE__ : "unknown",
  sendDefaultPii: true,
  normalizeDepth: 10,
  ignoreErrors: ignoredErrorFragments,
  beforeSend(event) {
    if (shouldDropIgnoredErrorEvent(event)) {
      return null;
    }

    return event;
  },
  integrations: [
    Sentry.captureConsoleIntegration(),
    Sentry.contextLinesIntegration(),
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration({ failedRequestStatusCodes: [[400, 599]] })
  ]
};

(function () {
  "use strict";

  if (window.sentryOptions && window.sentryOptions.enabled !== false && window.sentryInit !== true) {
    Sentry.init(window.sentryOptions);
    window.sentryInit = true;
  }

  angular.module("app", ["blockUI"]);
})();
